import { useHydrateAtoms } from 'jotai/utils';
import { MinorChildrenSection } from './ui/MinorChildrenSection';
import { AdultHouseholdSection } from './ui/AdultHouseholdSection';
import { profileAtom } from './model/store';
import { AdolescentSection } from './ui/AdolescentSection';
import {
    adolescentMinimumAgeAtom,
    adultMinimumAgeAtom,
    isAdolescentEnabledAtom,
} from '@/caregiverSpace/shared/model';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { VerticalContainer } from '@/components';
import { ISelfResponse } from '@/shared/interfaces';

type HouseholdAppProps = {
    selfResponse: ISelfResponse;
    canInvite: boolean;
    terms: string;
    isAdolescentEnabled: boolean;
    adolescentMinimumAge: number;
    adultMinimumAge: number;
};

export function Household({
    selfResponse,
    canInvite,
    terms,
    isAdolescentEnabled,
    adolescentMinimumAge,
    adultMinimumAge,
}: HouseholdAppProps) {
    useHydrateAtoms([
        [profileAtom, selfResponse],
        [isAdolescentEnabledAtom, isAdolescentEnabled],
        [adolescentMinimumAgeAtom, adolescentMinimumAge],
        [adultMinimumAgeAtom, adultMinimumAge],
    ]);
    return (
        <VerticalContainer spacing="md">
            <h2 id="heading-Household">{R.Household}</h2>
            <div
                className="text-text-primary max-w-prose whitespace-pre-line"
                dangerouslySetInnerHTML={{ __html: terms }}
            />
            <MinorChildrenSection />
            {isAdolescentEnabled && <AdolescentSection />}
            <AdultHouseholdSection canInvite={canInvite} />
        </VerticalContainer>
    );
}
